export const productTypes = [
  { value: "EV_STATION", name: "Estación de carga" },
  { value: "ACCESSORY", name: "Accesorios" },
  { value: "SERVICE", name: "Servicios" },
];
